import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set([
  'runtime-not-ready',
  'consent-copy',
  'validation',
]);

const fixtureRoutePattern = /^\/ai\/chatbots\/[^/]+$/;

export function isChatbotVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('chatbotVisualFixture') || '';

  return isLocalHost && fixtureRoutePattern.test(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const chatbotVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return isChatbotVisualFixtureUrl(window.location.href);
};
